import React from "react";
import { makeStyles } from "@mui/styles";
import { colors } from "src/colors/colors";

interface PropsI {
  children: React.ReactNode;
  className?: string;
}

const useStyles = makeStyles((theme) => {
  return {
    styles: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      background: colors.background.white,
      borderRadius: "16px",
    },
    contentContainer: {
      width: "75%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
        padding: '0px 8px'
      },
    },
  };
});
const ContainerContent = ({ children, className }: PropsI) => {
  const classes = useStyles();
  return (
    <div className={`${classes.styles} ${className}`}>
      <div className={classes.contentContainer}>{children}</div>
    </div>
  );
};

export default ContainerContent;
